module.exports = __webpack_public_path__ + "static/media/fruit-apple-1.1e296d7b.png";